import { applyCssTheme } from "./themeToCssHelper";

export const DEFAULT_THEME = {
  background: "light",
  accentColor: "#FF00AB",
  colors: {}
};

export const getDefaultState = () => {
  return DEFAULT_THEME;
};

// initial state
const state = getDefaultState();

const getters = {
  getActiveVenueSettings(state, getters, rootState, rootGetters) {
    return rootGetters["venueSettings/getVenueSettings"];
  },
  getThemeColors(state) {
    return state.colors;
  },
  getAccentColor(state) {
    return state.accentColor;
  },
  getThemeBackground(state) {
    return state.background;
  },
  getVenueIcon(state, getters, rootState, rootGetters) {
    return rootGetters["venue/getVenueInfo"]["imageUrl"];
  }
};

const actions = {
  fetchVenueTheme: function({ getters, commit }) {
    // Note: the endpoint is not ready yet. In the meantime we use the getActiveVenueSettings highlightColor
    // const themeInfo = await apiService.getTheme();
    const colors = {
      accentColor: getters.getActiveVenueSettings?.highlightColor || DEFAULT_THEME.accentColor
    };

    applyCssTheme(colors);
    commit("setColors", colors);
    commit("setAccentColor", colors.accentColor);
  }
};

const mutations = {
  resetState(state) {
    Object.assign(state, getDefaultState());
  },
  setColors(state, data) {
    state.colors = data;
  },
  setAccentColor(state, data) {
    state.accentColor = data;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
